// extracted by mini-css-extract-plugin
module.exports = {"gsapdGroupB":"groupcB_gsapdGroupB__0BEKX"};